import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFeed = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 32,
			height: 32,
			rx: 6,
			fill: "#24A2C2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.5 17.6667H17.6667V23.5H23.5V17.6667Z",
			stroke: "#DFF1FA",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.3333 17.6667H8.5V23.5H14.3333V17.6667Z",
			stroke: "#DFF1FA",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.5 8.5H17.6667V14.3333H23.5V8.5Z",
			stroke: "#DFF1FA",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.3333 8.5H8.5V14.3333H14.3333V8.5Z",
			stroke: "#DFF1FA",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgFeed;
